import { AxiosResponse } from "axios";
import { Hive, PaginationResponse } from "shared/types";

export type TNotificationType = 'info' | 'warning' | 'success' | 'error'
export type TNotificationRequestStatus = 'NEW' | 'READ' | null;

export enum TNotificationStatus {
  NEW = 'NEW',
  READ = 'READ'
}

export enum NotificationTypeEnum {
  INFO = 'INFO',
  DANGEROUS = 'DANGEROUS',
  ALERT = 'ALERT',
  WARNING = 'WARNING',
}

export enum NotificationSourceEnum {
  SENSOR = 'SENSOR',
  CALENDAR = 'CALENDAR',
  HUMIDITY = 'HUMIDITY',
  TEMPERATURE = 'TEMPERATURE',
  CO2 = 'CO2',
  INVITE = 'INVITE',
}

export type GetNotificationRequestParams = {
  apiaryId?: string;
  hiveIds?: string[] | string;
  hiveNumber?: number;
  status?: 'NEW' | 'READ';
  userId: string;
  dateFrom?: string;
  dateTo?: string;
  page?: PaginationResponse;
}

export type GetNotificationPresponse = {
  pagination: PaginationResponse;
  total: number;
  readCount: number;
  unreadCount: number;
  items: TNotification[];
}
export type TNotification = {
  id: string | number;
  status: TNotificationStatus;
  type: NotificationTypeEnum;
  source: NotificationSourceEnum;
  title: string;
  text: string;
  createdAt: string;
  hive: Hive;
  metadata: {
    [key: string]: any;
  }
}

export type Counters = {
  total: number;
  readCount: number;
  unreadCount: number;
}

export interface INotificationState {
  notifications: TNotification[];
  currentPage: number;
  pageSize: number;
  isEnd: boolean;
  lastParams: GetNotificationRequestParams | null;
  totalCounter: number;
  counters: Counters;
  getNotificationsFromServer: (params: GetNotificationRequestParams) => Promise<void>;
  getNextPage: () => Promise<void>;
  setNotificationStatusRead: (id: string) => Promise<void>
  readAll: (hiveId: string) => Promise<AxiosResponse>
}